import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { markTaskAsRead } from 'features/notifications/store/actions'
import { openPanel } from 'features/taskPanel/store/actions'
import { updateTaskPartiallyById, toggleCompleteTaskRequest } from 'features/task/store/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      markTaskAsRead,
      openPanel,
      toggleCompleteTaskRequest,
      updateTaskPartiallyById
    },
    dispatch
  )
})

const mapStateToProps = state => ({
  weeklyWorkingHours: state.session.user.weeklyWorkingHours
})

export default function wrapper(Component) {
  class CalendarContainer extends PureComponent {
    render() {
      return <Component {...this.props} />
    }
  }
  const containerRedux = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(CalendarContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/calendar/container.js